// extracted by mini-css-extract-plugin
export default {"overridesPrimaryDropdown":"PrimaryDropdown-module--overrides--PrimaryDropdown--G2CaS"};